routesConfig.$inject = ['$stateProvider'];

function routesConfig($stateProvider){
  $stateProvider
    .state('home.detailZone', {
      url: "zona-de-pagos/detalle",
      template: `<detail-zone sh-ctrl="shCtrl"></detail-zone>`
    });
}

export default routesConfig;



/** WEBPACK FOOTER **
 ** C:/wamp64/www/FRONTENDS/PROYECTOS SIESA/Projects_Azure/motos_paisa/NUEVO/motos-y-motos-el-paisa/www/components/pay-zone/detail-zone/detail-zone.config.js
 **/